import { render, staticRenderFns } from "./ReferralLinkForm.vue?vue&type=template&id=297788cf&scoped=true"
import script from "./ReferralLinkForm.vue?vue&type=script&lang=js"
export * from "./ReferralLinkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297788cf",
  null
  
)

export default component.exports